import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MessageCircle, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, WA_LINK, CATEGORIES } from "../lib/constants";

export const Footer = () => {
  return (
    <footer className="bg-[#0A192F] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logo}
              alt="TASSEI logo"
              className="h-14 w-auto object-contain bg-white rounded-md p-1"
            />
            <div>
              <div className="font-heading font-black text-xl">
                TASSEI<span className="text-[#00B37E]">.in</span>
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-white/60 mt-0.5">
                Sapno Se Safalta Tak
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs">
            <span className="font-semibold text-white">TASSEI</span> —{" "}
            {BRAND.fullForm}. Building India&apos;s No. 1 Career Success Ecosystem.
          </p>
          <a
            href={WA_LINK()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-consultation-cta"
            className="inline-flex items-center gap-2 mt-6 px-5 py-3 rounded-full bg-[#00B37E] hover:bg-[#009166] transition-colors text-sm font-semibold"
          >
            <MessageCircle className="w-4 h-4" /> Book Free Consultation
          </a>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#00B37E]">
            Explore
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#00B37E] transition-colors" data-testid={`footer-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#00B37E]">
            Categories
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            {CATEGORIES.map((c) => (
              <li key={c.id}>
                <Link to={`/courses?cat=${c.id}`} className="hover:text-[#00B37E] transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#00B37E]">
            Contact
          </h4>
          <ul className="mt-5 space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#00B37E]" />
              <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-[#00B37E] transition-colors" data-testid="footer-phone">
                {BRAND.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 mt-0.5 text-[#00B37E]" />
              <a
                href={WA_LINK("Hi TASSEI, I need help")}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00B37E] transition-colors"
                data-testid="footer-whatsapp"
              >
                WhatsApp Us
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#00B37E]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[#00B37E] transition-colors">
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Globe className="w-4 h-4 mt-0.5 text-[#00B37E]" />
              <a href={`https://${BRAND.website}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#00B37E] transition-colors">
                {BRAND.website}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#00B37E]" />
              <span>Delhi · Expanding in India soon</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3">
            <span>© {new Date().getFullYear()} TASSEI.in — All rights reserved.</span>
            <span className="hidden md:inline text-white/30">·</span>
            <span className="text-[#7CF0BD] font-semibold" data-testid="footer-msme">
              MSME Registered · UDYAM-DL-08-0131214
            </span>
          </div>
          <div className="uppercase tracking-[0.18em]">
            Talent · Acceleration · Skill · Success · Ecosystem of India
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
